import { render, staticRenderFns } from "./FormUploadVideo.vue?vue&type=template&id=aa298492"
import script from "./FormUploadVideo.vue?vue&type=script&lang=js"
export * from "./FormUploadVideo.vue?vue&type=script&lang=js"
import style0 from "./FormUploadVideo.vue?vue&type=style&index=0&id=aa298492&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports